/* istanbul ignore file */
import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment';
import { toast } from 'react-toastify';
import {
  Chip,
  Collapse,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  TableSortLabel,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import EditIcon from '@material-ui/icons/Edit';
import BlockIcon from '@material-ui/icons/Block';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import messages from 'containers/LawyerFeeNote/messages';
import { DOCUMENT_TYPES, ROW_PER_PAGE } from 'constants/global';
import _, { get, isEmpty, isNull, isNil } from 'lodash';
import { COLORS } from 'constants/design';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  couldDoActionOn,
  dhAmount,
  isRejectedStep,
  setColor,
  stepWithDocumentType,
  stepWithoutDocument,
  displayReasonBlockFeeNoteDecision,
  couldEditOpeningFeeNote,
  formatUpdateInvoiceFeeNote,
  formaAddInvoiceFeeNote,
  isPendingFeeNote,
  couldEditInvoices,
  renderAmountHt,
  renderAmountTtc,
} from 'containers/LawyerFeeNote/utils';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import RoundPrimaryButton from 'components/Buttons/RoundPrimaryButton';
import { handleCollapseRow } from 'containers/LawyerDocumentsPage/utils';
import useCollapse from 'hooks/useCollapse';
import FeeNoteDrawer from 'containers/LawyerFeeNote/FeeNoteDrawer';
import {
  isValidatedOrPendingJudgement,
  shouldDisplayPinEdit,
  formatCostToAdd,
} from 'containers/LawyerFeeNote/utils';
import { translate } from 'containers/services/translate';
import {
  ACTION,
  DOC_MESSAGES,
  LIMIT_DATE_INVOICE,
  STATUS_MESSAGES,
  STATUS_PENDING,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import FeeNoteActionsDialog from 'containers/LawyerFeeNote/FeeNoteActionsDialog';
import Document from 'components/Document';
import { isTransactionManager } from 'helpers/utils';
import userPrivelges from 'containers/services/security/user-privileges';
import { CollapseContainer } from 'containers/LawyerFeeNote/styled-components';
import { DOCUMENT, FEE_NOTE, FEE_NOTE_STEP } from 'containers/data-structure';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
  getLimitValidationInvoiceManager,
  handleOpenDocument,
} from 'services/utils';
import ChecksBox from 'containers/LawyerFeeNote/ChecksBox';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import FeeNoteUpdateAmountDialog from 'containers/LawyerFeeNote/FeeNoteUpdateAmountDialog';
import FeeNoteUpdateStatusDialog from 'containers/LawyerFeeNote/FeeNoteUpdateStatusDialog';
import InvoiceFeeNoteRecap from 'containers/LawyerFeeNote/InvoiceFeeNoteRecap';
import withLoading from 'containers/AppContainer/withLoading';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import { isDesactivateIntervenant } from 'services/utils';
import {
  renderInvoiceFeeNoteControlAction,
  couldAddInvoiceInfo,
} from 'containers/LawyerFeeNote/utils';
import { isPendingApprovalClaim } from 'containers/LawyerLegalProceedingsPage/utils';
import { requestRejectFeeNoteLawyer } from 'containers/LawyerFeeNote/actions';
import RejectFeeNoteByLawyerDialog from 'containers/LawyerFeeNote/RejectFeeNoteByLawyerDialog';
import { useTesseract } from 'hooks/useTesseract';
import InvoiceDocumentInfo from 'containers/LawyerFeeNote/invoiceDocumentInfo';

// style
const menuMargin = {
  marginTop: '40px',
};
const iconRejection = {
  color: '#f72b2b',
};
const chipContainer = {
  display: 'flex',
  TextAlign: 'center',
  verticalAlign: 'middle',
};
const chipMessage = {
  margin: '4px',
  marginLeft: '0px',
};
const chipBody = {
  backgroundColor: '#EDEEEE',
  paddingLeft: '5px',
};

const iconSize = { width: '10px' };
const addBtnWidth = { width: '22px' };
const fontSize = { fontSize: '16px' };

const tableCellStyle = {
  paddingBottom: 0,
  paddingTop: 0,
  backgroundColor: '#f7f7f7',
};

export interface FeeNoteTableProps {
  intl: IntlShape;
  feeNotes: FeeNote[];
  requestFeeNotes: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteCosts: Function;
  keyclokToken: string | null;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  documentId: string;
  setDocumentId: Function;
  isManager?: boolean;
  status?: string;
  showButtonAdd: boolean;
  makeDecisionFeeNote?: Function;
  claimNumber?: string;
  listings: Listings;
  allFeeNotes?: FeeNote[];
  requestAllFeeNotes: Function;
  viewByClaim: boolean;
  showStatusColumn?: boolean;
  selectedStatus?: null | string;
  feeNotesCount: number;
  page: number;
  setPage: Function;
  linkToBeneficiaryCodes?: SagisConfig[];
  isExpert?: boolean;
  requestUpdateFeeNoteAmount?: Function;
  requestUpdateFeeNoteStatus?: Function;
  notifFeeNote?: any;
  requestManagerAllFeeNotes: Function;
  loaders?: any;
  setNotificationFeeNote?: Function;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestAllLawyerFeeNotes?: Function;
  isConsultation?: boolean;
  requestCreateCostsSagis: Function;
  requestGetDocByDocumentumId: Function;
  requestUpdateFirmReferenceManager: Function;
}

export const FeeNoteTable: React.FC<FeeNoteTableProps> = (
  props,
): JSX.Element => {
  const [invoiceExtractingText, setInvoiceExtractingText] = useState(null);
  const {
    recognizeFromUrl,
    text,
    invoiceInfo,
    loading,
    setInvoiceInfo,
  } = useTesseract('fra', setInvoiceExtractingText);
  const { showStatusColumn = true } = props;
  const dispatch = useDispatch();
  const [expandRow, setExpandRow] = useCollapse(props.feeNotes);

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [currentClaimNumber, setCurrentClaimNumber] = useState('');
  const [currentClaimId, setCurrentClaimId] = useState<number | null>(null);
  const [openInvoiceFeeNoteInfo, setOpenInvoiceFeeNoteInfo] = useState(false);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceReceptionDate, setInvoiceReceptionDate] = React.useState(null);
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceFeeNoteId, setInvoiceFeeNoteId] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [pageSize, setRowsPerPage] = React.useState<number>(25);

  const [actionDialog, setActionDialog] = React.useState<string>(ACTION.CLOSED);
  const [openRejetFeeNoteDialog, setOpenRejetFeeNoteDialog] = React.useState<
    boolean
  >(false);

  const [openDialogFeeNoteAmount, setOpenDialogFeeNoteAmount] = React.useState<
    boolean
  >(false);
  const [openUpdateStatusFeeNote, setOpenUpdateStatusFeeNote] = React.useState<
    boolean
  >(false);
  const [drawerPayload, setDrawerPayload] = React.useState({
    feeNoteIndex: 0,
  });
  const [orderedData, setOrderedData] = React.useState<FeeNote[]>([]);
  const [order, setOrder] = React.useState<string>('desc');
  const [orderStep, setOrderStep] = React.useState<string>('desc');

  React.useEffect(() => {
    if (
      props.keyclokToken &&
      !props.isManager &&
      !props.selectedStatus &&
      isEmpty(props.notifFeeNote)
    ) {
      props.requestAllFeeNotes(props.page, pageSize);
    } else if (
      props.keyclokToken &&
      props.isManager &&
      !props.status &&
      isEmpty(props.notifFeeNote)
    ) {
      props.requestAllFeeNotes(props.page, pageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.keyclokToken]);

  React.useEffect(() => {
    setOrderedData(props.feeNotes);
  }, [props.feeNotes]);
  React.useEffect(() => {
    if (
      props.isManager &&
      props.status &&
      isEmpty(props.notifFeeNote) &&
      !isTransactionManager()
    ) {
      props.requestFeeNotes(props.status, props.page, pageSize);
    } else if (
      props.isManager &&
      props.status &&
      isEmpty(props.notifFeeNote) &&
      isTransactionManager() &&
      !isEmpty(get(props.listings, 'transactionInboxeArea', []))
    ) {
      const transactionInboxeAreaIds = userPrivelges
        .getUserInboxes()
        .map((el: any) =>
          !isNil(el.transactionInboxeAreaId)
            ? el.transactionInboxeAreaId
            : undefined,
        );
      const transactionAreaIds = transactionInboxeAreaIds.map((item: any) =>
        get(
          get(props.listings, 'transactionInboxeArea', []).find(
            (el: any) => el.id === item,
          ),
          'transactionAreaId',
        ),
      );
      props.requestFeeNotes(
        props.status,
        props.page,
        pageSize,
        transactionAreaIds,
      );
    } else if (
      props.keyclokToken &&
      !props.isManager &&
      props.selectedStatus &&
      isEmpty(props.notifFeeNote)
    ) {
      props.requestFeeNotes(props.selectedStatus, props.page, pageSize);
    }
  }, [
    props.selectedStatus,
    props.status,
    pageSize,
    props.page,
    props.keyclokToken,
    props.listings,
  ]);
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const size = parseInt(event.target.value, 10);
    setRowsPerPage(size);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    props.setPage(newPage);
  };
  const toggleDrawer = (index: number) => {
    setDrawerOpen(!isDrawerOpen);
    setDrawerPayload({ ...drawerPayload, feeNoteIndex: index });
  };
  const successCallBack = () => {
    toast.success(translate(messages.feeNoteUpdateSuccess, props));
    props.requestFeeNotes(
      get(props, 'status', `${props.selectedStatus}`),
      props.page,
      pageSize,
    );
  };
  const handleCloseDialogFeeNoteAmount = () => {
    setOpenDialogFeeNoteAmount(false);
  };
  const handleCloseDialogFeeNoteStatus = () => {
    setOpenUpdateStatusFeeNote(false);
  };

  const handleSubmit = (feeNote: FeeNote) => {
    if (
      get(feeNote, 'status', null) === STATUS_VALIDATED &&
      props.isManager &&
      featureService.hasFeature(FEATURES.ADD_COST_SAGIS)
    ) {
      props.requestCreateCostsSagis(
        formatCostToAdd(feeNote, props.listings),
        successCallBack,
      );
    } else {
      props.requestFeeNoteCosts(
        {
          ...feeNote,
          id: undefined,
          createdBy: props.isManager
            ? currentUserStorage.get().username
            : currentIntervenantStorage.get().preferred_username,
          claimNumber: currentClaimNumber,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          status: STATUS_PENDING,
          isLawyer: !props.isManager,
          username: props.isManager
            ? currentUserStorage.get().username
            : currentIntervenantStorage.get().preferred_username,
        },
        successCallBack,
      );
    }
  };
  const [feeNoteToValidate, setFeeNoteToValidate] = useState(null);
  const [beneficiaryFeeNote, setBeneficiaryFeeNote] = useState('');
  const [selectedFeeNote, setSelectedFeeNotee] = useState(null);

  const [menuAnchorEl, setMenuAnchorEl] = useState({
    toOpen: null,
    firmReference: null,
    index: null,
    isPendingApprovalClaim: null,
    feeNoteMission: null,
    isRejectedStep: null,
    isInvoiceIssue: null,
    isEmptyAmountTtc: null,
  });

  const openMenu = (
    index: any,
    beneficiary: string,
    firmReference: any,
    id: number,
    isPendingApprovalClaim: boolean,
    feeNoteMission: any,
    isRejectedStep: boolean,
    isInvoiceIssue: boolean,
    isEmptyAmountTtc: boolean,
  ) => (event: any) => {
    setCurrentClaimId(get(orderedData[id], 'claimId'));
    setCurrentClaimNumber(get(orderedData[id], ['claim', 'claimNumber']));
    setMenuAnchorEl({
      toOpen: event.currentTarget,
      firmReference,
      index,
      isPendingApprovalClaim,
      feeNoteMission,
      isRejectedStep,
      isInvoiceIssue,
      isEmptyAmountTtc,
    } as any);
    setFeeNoteToValidate(index);
    setBeneficiaryFeeNote(beneficiary);
  };

  const handleAction = (action: string) => {
    setActionDialog(action);
    handleCloseMenu();
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl({
      toOpen: null,
      index: null,
      firmReference: null,
      isPendingApprovalClaim: null,
      feeNoteMission: null,
      isRejectedStep: null,
      isInvoiceIssue: null,
      isEmptyAmountTtc: null,
    });
  };

  const handleCloseDialog = () => {
    setActionDialog(ACTION.CLOSED);
  };
  const sortDate = (data: any) => {
    setOrder('asc');
    const sortedData = _.orderBy(data, 'createdAt', ['desc']);
    setOrderedData(sortedData as FeeNote[]);
    return sortedData;
  };
  const unSortDate = (data: any) => {
    setOrderStep('desc');
    const sortedData = _.orderBy(data, 'createdAt', ['asc']);
    setOrderedData(sortedData as FeeNote[]);
    return sortedData;
  };
  const sortByStep = (data: any) => {
    setOrderStep('asc');
    const sortedData = _.orderBy(data, 'step', ['desc']);
    setOrderedData(sortedData as FeeNote[]);
    return sortedData;
  };
  const unSortByStep = (data: any) => {
    setOrderStep('desc');
    const sortedData = _.orderBy(data, 'step', ['asc']);
    setOrderedData(sortedData as FeeNote[]);
    return sortedData;
  };
  const cleanStateInvoiceInfo = () => {
    setInvoiceNumber(null);
    setInvoiceDocument({});
    setInvoiceReceptionDate(null);
    setInvoiceFeeNoteId(null);
    setInvoiceDate(null);
  };
  const successCallBackInvoice = () => {
    setOpenInvoiceFeeNoteInfo(false);
    toast.success(translate(messages.feeNoteUpdateSuccess, props));
    if (props.viewByClaim) {
      props.requestFeeNotes(get(orderedData, '[0].claim.claimNumber'));
    } else {
      props.requestFeeNotes(
        get(props, 'status', `${props.selectedStatus}`),
        props.page,
        pageSize,
      );
    }

    cleanStateInvoiceInfo();
  };
  const handleOpenUpdateDialog = (row: any) => {
    setInvoiceNumber(get(row, 'invoiceFeeNote.invoiceNumber', null));
    setInvoiceDate(get(row, 'invoiceFeeNote.invoiceDate', null));
    setInvoiceReceptionDate(get(row, 'invoiceFeeNote.receptionDate', null));
    setInvoiceDocument({
      url: get(row, 'invoiceFeeNote.url', null),
      type: get(row, 'invoiceFeeNote.type', null),
      name: get(row, 'invoiceFeeNote.name', null),
    });
    setSelectedFeeNotee(row);
    setInvoiceFeeNoteId(get(row, 'invoiceFeeNote.id', null));
    setOpenInvoiceFeeNoteInfo(true);
  };
  const handleValidateInvoiceFeeNote = (payload: any) => {
    if (!isNil(invoiceFeeNoteId)) {
      props.requestUpdateInvoiceFeeNote(
        formatUpdateInvoiceFeeNote(invoiceFeeNoteId, payload),

        successCallBackInvoice,
      );
    } else {
      props.requestAddInvoiceFeeNote(
        formaAddInvoiceFeeNote(payload),
        successCallBackInvoice,
      );
    }
  };
  const innerChip = (
    step: string,
    status: string,
    index: number,
    beneficiary: string,
    firmReference: string,
    id: number,
    row: any,
  ) => {
    let message = translate({ ...get(STATUS_MESSAGES, status) }, props);
    const isManager = props.isManager ? props.isManager : false;
    if (
      status !== STATUS_PENDING ||
      !couldDoActionOn(step, isManager) ||
      props.isConsultation
    )
      return <div>{message}</div>;
    return (
      <div
        onClick={openMenu(
          index,
          beneficiary,
          firmReference,
          id,
          isPendingApprovalClaim(row),
          get(row, 'feeNoteMission', null),
          isRejectedStep(row),
          couldAddInvoiceInfo(row, props.listings) ||
            renderInvoiceFeeNoteControlAction(row, props.listings),
          isNil(get(row, 'amountTtc', null)) && isNil(get(row, 'costs', null)),
        )}
        aria-label="expand-menu"
        style={chipContainer}
      >
        <div style={chipMessage}>{message}</div>
        {menuAnchorEl.index === index ? (
          <KeyboardArrowUpIcon />
        ) : (
          <KeyboardArrowDownIcon />
        )}
      </div>
    );
  };
  const successCallBackRejectFeeNote = () => {
    toast.success(translate(messages.toastSuccessRejectFeeNote, props));
    setOpenRejetFeeNoteDialog(false);
  };
  const handleRejectFeeNote = (feeNoteId: number) => {
    dispatch(
      requestRejectFeeNoteLawyer(
        { id: feeNoteId },
        successCallBackRejectFeeNote,
      ),
    );
  };

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left" className="headerTitle">
              {translate({ ...messages.claimNumber }, props)}
            </TableCell>

            <TableCell align="left" className="headerTitle">
              <TableSortLabel
                active={true}
                direction={orderStep === 'desc' ? 'desc' : 'asc'}
                onClick={() =>
                  orderStep === 'desc'
                    ? sortByStep(props.feeNotes as any)
                    : unSortByStep(props.feeNotes as any)
                }
              >
                {translate({ ...messages.step }, props)}
              </TableSortLabel>
            </TableCell>

            <TableCell align="left" className="headerTitle">
              <TableSortLabel
                active={true}
                direction={order === 'desc' ? 'desc' : 'asc'}
                onClick={() =>
                  order === 'desc'
                    ? sortDate(props.feeNotes as any)
                    : unSortDate(props.feeNotes as any)
                }
              >
                {translate({ ...messages.creationDate }, props)}
              </TableSortLabel>
            </TableCell>
            <TableCell align="left" className="headerTitle">
              {translate({ ...messages.beneficiary }, props)}
            </TableCell>
            <TableCell align="left" className="headerTitle">
              {props.isExpert
                ? translate({ ...messages.missionReference }, props)
                : translate({ ...messages.firmReference }, props)}
            </TableCell>
            <TableCell align="left" className="headerTitle">
              {translate({ ...messages.feeNoteFrais }, props)}
            </TableCell>
            <TableCell align="right" className="headerTitle">
              {translate({ ...messages.amountTtc }, props)}
            </TableCell>
            <TableCell align="right" className="headerTitle">
              {translate({ ...messages.amountHt }, props)}
            </TableCell>
            <TableCell align="right" className="headerTitle">
              {translate({ ...messages.judgementDate }, props)}
            </TableCell>
            <TableCell align="right" className="headerTitle">
              {translate({ ...messages.judiciaryProcess }, props)}
            </TableCell>
            {showStatusColumn && (
              <TableCell align="center" className="headerTitle">
                {translate({ ...messages.status }, props)}
              </TableCell>
            )}
            {props.selectedStatus &&
              props.selectedStatus === STATUS_REJECTED && (
                <TableCell align="center">
                  {translate({ ...messages.motif }, props)}
                </TableCell>
              )}
            <TableCell align="left" className="headerTitle">
              {/* Action cell */}
            </TableCell>
          </TableRow>
        </TableHead>
        {!isEmpty(orderedData) &&
          orderedData.map((row: any, index: number) => (
            <TableBody key={index}>
              <TableRow key={row.id} id="table-row">
                <TableCell align="left" className="row">
                  {get(row, ['claim', 'claimNumber'])}
                </TableCell>

                <TableCell align="left" className="row">
                  {!isEmpty(get(row, 'document', {}))
                    ? stepWithDocumentType(
                        row.step,
                        get(row, 'document', {}),
                        props,
                      )
                    : row.step === DOCUMENT_TYPES.PV && row.costs
                    ? translate(messages.pvCosts, props)
                    : stepWithoutDocument(row.step, props)}
                </TableCell>
                <TableCell align="left" className="row">
                  {moment(row.createdAt).format('YYYY-MM-DD')}
                </TableCell>
                <TableCell align="left" className="row">
                  {isDesactivateIntervenant(
                    get(props.listings, 'intervenants', []),
                    get(row, 'codeIntervenant', ''),
                  )
                    ? getValueByCode(
                        get(row, 'codeIntervenant', ''),
                        get(props.listings, 'inactiveIntervenants', []),
                      ) + '(Inactif)'
                    : getValueByCode(
                        get(row, 'codeIntervenant', ''),
                        get(props.listings, 'intervenants', []),
                      )}
                </TableCell>
                <TableCell align="left" className="row">
                  {props.isExpert
                    ? get(row, 'feeNoteMission.mission.reference')
                    : get(row, 'firmReference')
                    ? get(row, 'firmReference')
                    : get(row, 'feeNoteMission.mission.reference')}
                </TableCell>
                <TableCell align="right" className="row">
                  {row.costs ? dhAmount(row.costs) : '-'}
                </TableCell>
                <TableCell align="right" className="row">
                  {renderAmountTtc(row)}
                </TableCell>
                <TableCell align="right" className="row">
                  {renderAmountHt(row)}
                </TableCell>
                <TableCell align="right" className="row">
                  {row.judgementDate &&
                    moment(row.judgementDate).format('YYYY-MM-DD')}
                </TableCell>
                <TableCell align="right" className="row">
                  {row.courtNumber && String(row.courtNumber).toUpperCase()}
                </TableCell>
                {showStatusColumn && (
                  <TableCell align="center" className="row">
                    <Chip
                      style={chipBody}
                      className=""
                      label={innerChip(
                        row.step,
                        row.status,
                        row.id,
                        row.beneficiary,
                        props.isExpert
                          ? get(row, 'feeNoteMission.mission.reference', null)
                          : get(row, 'firmReference')
                          ? get(row, 'firmReference', null)
                          : get(row, 'feeNoteMission.mission.reference', null),
                        index,
                        row,
                      )}
                      icon={
                        <Brightness1Icon
                          style={{
                            color: setColor(row.status),
                            ...iconSize,
                          }}
                        />
                      }
                    />
                  </TableCell>
                )}
                {props.selectedStatus &&
                  props.selectedStatus === STATUS_REJECTED && (
                    <TableCell align="center">{row.comment}</TableCell>
                  )}
                <TableCell align="center">
                  <>
                    {!props.isConsultation && (
                      <Grid>
                        {couldEditOpeningFeeNote(row) &&
                          couldAddInvoiceInfo(row, props.listings) && (
                            <div
                              onClick={() => {
                                setSelectedFeeNotee(row);
                                setOpenInvoiceFeeNoteInfo(true);
                              }}
                            >
                              <Tooltip
                                title={translate(
                                  messages.addInvoiceTitle,
                                  props,
                                )}
                                placement={'top'}
                                aria-label="add"
                              >
                                <ReceiptIcon
                                  style={{
                                    height: '20px',
                                    width: '20px',
                                    cursor: 'pointer',
                                    color: COLORS.GREY,
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                        {!props.isManager &&
                          !props.isExpert &&
                          isPendingFeeNote(row) && (
                            <div
                              onClick={() => {
                                setSelectedFeeNotee(row);
                                setOpenRejetFeeNoteDialog(true);
                              }}
                            >
                              <Tooltip
                                title={translate(
                                  messages.rejectFeeNoteTitle,
                                  props,
                                )}
                                aria-label="add"
                              >
                                <BlockIcon
                                  style={{
                                    height: '20px',
                                    width: '20px',
                                    cursor: 'pointer',
                                    color: COLORS.RED,
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                      </Grid>
                    )}
                    {!props.isConsultation &&
                      couldEditOpeningFeeNote(row) &&
                      shouldDisplayPinEdit(
                        row,
                        props.isManager,
                        props.listings,
                      ) && (
                        <div
                          onClick={() => {
                            setSelectedFeeNotee(row);
                            if (
                              row.step ===
                                FEE_NOTE_STEP.EXPERTISE_CONSEIL_APPRECIATION &&
                              row.status === STATUS_PENDING &&
                              userPrivileges.userHasPrivilege(
                                PRIVILEGES.ISMANAGER,
                              )
                            ) {
                              setOpenDialogFeeNoteAmount(true);
                            } else if (!isValidatedOrPendingJudgement(row)) {
                              setOpenUpdateStatusFeeNote(true);
                            }
                          }}
                        >
                          <EditIcon
                            style={{
                              height: '20px',
                              width: '20px',
                              marginRight: '8px',
                              cursor: 'pointer',
                              color: COLORS.BLUE_MENU_PRIMARY,
                            }}
                          />
                        </div>
                      )}
                    {((featureService.hasFeature(
                      FEATURES.ATTRIBUTION_INBOXES_MANAGER,
                    ) &&
                      couldDoActionOn(
                        row.step,
                        props.isManager ? props.isManager : false,
                      ) &&
                      isRejectedStep(row)) ||
                      (featureService.hasFeature(
                        FEATURES.BILLING_INFO_FEE_NOTE,
                      ) &&
                        couldDoActionOn(
                          row.step,
                          props.isManager ? props.isManager : false,
                        ))) &&
                      props.isManager && (
                        <span style={{ color: '#f72b2b' }}>
                          {displayReasonBlockFeeNoteDecision(
                            row,
                            props.listings,
                          )}
                        </span>
                      )}
                  </>
                </TableCell>
                <TableCell>
                  {props.showButtonAdd ? (
                    <RoundPrimaryButton
                      aria-label="button-add"
                      className="button-space"
                      name="round-button"
                      onClick={() => toggleDrawer(index)}
                      lefticon={<AddCircleOutlineIcon style={addBtnWidth} />}
                    />
                  ) : (
                    <></>
                  )}
                  {row.status === STATUS_REJECTED ? (
                    <Tooltip title={row.comment} aria-label="add">
                      <IconButton aria-label="add an alarm">
                        <ErrorOutlineRoundedIcon style={iconRejection} />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <></>
                  )}

                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={handleCollapseRow(
                      index,
                      expandRow,
                      setExpandRow,
                      () => {
                        setInvoiceInfo({} as any);
                      },
                    )}
                  >
                    {expandRow && expandRow[index] ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </IconButton>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12} style={tableCellStyle}>
                  <Collapse
                    in={expandRow && expandRow[index]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <CollapseContainer className="fee-notes-container">
                      {true && ( // api non implémenté
                        <Grid container direction="column">
                          <Grid item>
                            <div className="cheque-container">
                              <div className="title">
                                {translate(messages.check, props)}
                              </div>
                              <ChecksBox
                                regulations={get(row, 'regulations[0]')}
                                checkNumber={get(row, 'checkNumber')}
                              />
                            </div>
                          </Grid>
                          {featureService.hasFeature(
                            FEATURES.BILLING_INFO_FEE_NOTE,
                          ) &&
                            !isNil(get(row, 'invoiceFeeNote', null)) && (
                              <Grid item>
                                <div className="title">
                                  {translate(messages.invoiceTitleData, props)}

                                  {get(row, 'status', null) !=
                                    STATUS_VALIDATED &&
                                    couldEditInvoices(row) &&
                                    !props.isConsultation && (
                                      <EditIcon
                                        style={{
                                          height: '20px',
                                          width: '20px',
                                          marginLeft: '20px',
                                          cursor: 'pointer',
                                          color: 'rgba(9, 122, 194, 1)',
                                        }}
                                        onClick={() =>
                                          handleOpenUpdateDialog(row)
                                        }
                                      />
                                    )}
                                </div>
                                {!isNil(get(row, 'invoiceFeeNote.url', null)) &&
                                  featureService.hasFeature(
                                    FEATURES.LIMIT_INVOICE_DATE,
                                  ) &&
                                  props.isManager && (
                                    <InvoiceDocumentInfo
                                      recognizeFromUrl={recognizeFromUrl}
                                      callApi={
                                        !isNil(
                                          get(row, 'invoiceFeeNote.url', null),
                                        ) &&
                                        expandRow &&
                                        expandRow[index]
                                      }
                                      invoiceUrl={get(
                                        row,
                                        'invoiceFeeNote.url',
                                        null,
                                      )}
                                      isLoading={loading}
                                      extractedData={invoiceInfo}
                                    />
                                  )}
                                <InvoiceFeeNoteRecap
                                  InvoiceInfo={get(row, 'invoiceFeeNote')}
                                  requestGetDocByDocumentumId={
                                    props.requestGetDocByDocumentumId
                                  }
                                />
                              </Grid>
                            )}
                        </Grid>
                      )}

                      {get(row, [FEE_NOTE.DOCUMENT, DOCUMENT.NAME], '') && (
                        <div className="pj-container">
                          <div className="title">
                            {translate(messages.pj, props)}
                          </div>
                          <Document
                            name={get(
                              row,
                              [FEE_NOTE.DOCUMENT, DOCUMENT.NAME],
                              '',
                            )}
                            type={
                              get(
                                DOC_MESSAGES,
                                get(
                                  row,
                                  [FEE_NOTE.DOCUMENT, DOCUMENT.TYPE],
                                  '',
                                ),
                              )
                                ? translate(
                                    {
                                      ...get(
                                        DOC_MESSAGES,
                                        get(
                                          row,
                                          [FEE_NOTE.DOCUMENT, DOCUMENT.TYPE],
                                          '',
                                        ),
                                      ),
                                    },
                                    props,
                                  )
                                : ''
                            }
                            icon={
                              <VisibilityIcon
                                className="consult"
                                onClick={handleOpenDocument(
                                  get(row, [FEE_NOTE.DOCUMENT], {}),
                                  props.requestGetDocByDocumentumId,
                                )}
                              />
                            }
                          />
                        </div>
                      )}
                    </CollapseContainer>
                  </Collapse>
                </TableCell>
              </TableRow>
            </TableBody>
          ))}
      </Table>
      <TablePagination
        rowsPerPageOptions={ROW_PER_PAGE}
        component="div"
        count={props.feeNotesCount}
        rowsPerPage={pageSize}
        page={props.page}
        labelRowsPerPage={translate({ ...messages.linesPerPage }, props)}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      {Boolean(menuAnchorEl.toOpen) && (
        <Menu
          id="action-menu"
          data-testid="action-menu"
          anchorEl={menuAnchorEl.toOpen}
          keepMounted
          open={Boolean(menuAnchorEl.toOpen)}
          onClose={handleCloseMenu}
          style={menuMargin}
        >
          {(userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
            ? userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
            : (userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
                userPrivileges.userHasPrivilege(
                  PRIVILEGES.ISTRANSACTIONMANAGER,
                )) &&
              menuAnchorEl?.firmReference !== null) &&
            !menuAnchorEl?.isPendingApprovalClaim &&
            !menuAnchorEl?.isRejectedStep &&
            !menuAnchorEl?.isInvoiceIssue &&
            !menuAnchorEl.isEmptyAmountTtc && (
              <MenuItem
                onClick={() => handleAction(ACTION.VALIDATE)}
                data-testid="validate-action"
                style={fontSize}
              >
                {translate({ ...messages.actionValidate }, props)}
              </MenuItem>
            )}
          {(userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) ||
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) &&
            menuAnchorEl?.firmReference === null &&
            !menuAnchorEl?.isPendingApprovalClaim &&
            !menuAnchorEl?.isRejectedStep &&
            !menuAnchorEl?.isInvoiceIssue &&
            !menuAnchorEl.isEmptyAmountTtc &&
            isEmpty(menuAnchorEl.feeNoteMission) && (
              <MenuItem
                onClick={() => handleAction(ACTION.ADD_FIRM_REFERENCE)}
                data-testid="add-firm-reference-action"
                style={fontSize}
              >
                {translate({ ...messages.actionChangeFirmReference }, props)}
              </MenuItem>
            )}
          <MenuItem
            onClick={() => handleAction(ACTION.REJECT)}
            data-testid="reject-action"
            style={fontSize}
          >
            {translate({ ...messages.actionReject }, props)}
          </MenuItem>
        </Menu>
      )}
      {props.isManager && props.makeDecisionFeeNote && (
        <FeeNoteActionsDialog
          allFeeNotes={props.allFeeNotes}
          // eslint-disable-next-line eqeqeq
          open={actionDialog != ACTION.CLOSED}
          action={actionDialog}
          beneficiary={beneficiaryFeeNote}
          id={Number(feeNoteToValidate)}
          makeDecisionFeeNote={props.makeDecisionFeeNote}
          handleClose={handleCloseDialog}
          requestFeeNotes={props.requestFeeNotes}
          claimNumber={currentClaimNumber}
          claimId={currentClaimId}
          page={props.page}
          pageSize={pageSize}
          feeNotes={props.feeNotes}
          listings={props.listings}
          viewByClaim={props.viewByClaim}
          linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
          setNotificationFeeNote={props.setNotificationFeeNote}
          requestUpdateFirmReferenceManager={
            props.requestUpdateFirmReferenceManager
          }
          limitValidationInvoiceDate={getLimitValidationInvoiceManager(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
      {isDrawerOpen && (
        <FeeNoteDrawer
          open={isDrawerOpen}
          feeNote={props.feeNotes[drawerPayload.feeNoteIndex]}
          isManager={props.isManager ? props.isManager : false}
          handleToggleDrawer={toggleDrawer}
          handleSubmit={handleSubmit}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          limitInvoiceDate={
            props.isManager
              ? getLimitInvoiceManager(get(props.listings, 'appConfig', []))
              : getLimitInvoiceIntervenant(get(props.listings, 'appConfig', []))
          }
        />
      )}
      {openDialogFeeNoteAmount && props.isManager && (
        <FeeNoteUpdateAmountDialog
          open={openDialogFeeNoteAmount}
          onClose={handleCloseDialogFeeNoteAmount}
          validateDialog={
            props.requestUpdateFeeNoteAmount
              ? props.requestUpdateFeeNoteAmount
              : () => {}
          }
          requestFeeNotes={props.requestFeeNotes}
          viewByClaim={props.viewByClaim}
          feeNote={selectedFeeNote as any}
          page={props.page}
          pageSize={pageSize}
          claimNumber={currentClaimNumber}
        />
      )}
      {openUpdateStatusFeeNote && (
        <FeeNoteUpdateStatusDialog
          open={openUpdateStatusFeeNote}
          onClose={handleCloseDialogFeeNoteStatus}
          validateDialog={
            props.requestUpdateFeeNoteStatus
              ? props.requestUpdateFeeNoteStatus
              : () => {}
          }
          requestFeeNotes={props.requestFeeNotes}
          viewByClaim={props.viewByClaim}
          feeNote={selectedFeeNote as any}
          page={props.page}
          pageSize={pageSize}
          claimNumber={currentClaimNumber}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfo}
          onClose={() => setOpenInvoiceFeeNoteInfo(false)}
          handleValidate={() =>
            handleValidateInvoiceFeeNote({
              invoiceNumber,
              invoiceDate,
              invoiceReceptionDate: props.isManager
                ? invoiceReceptionDate
                : moment().format('YYYY-MM-DD'),
              selectedFeeNote,
              invoiceDocument: invoiceDocument,
            })
          }
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceReceptionDate={invoiceReceptionDate}
          setInvoiceReceptionDate={setInvoiceReceptionDate}
          isManager={props.isManager}
          limitInvoiceDate={
            props.isManager
              ? getLimitInvoiceManager(get(props.listings, 'appConfig', []))
              : getLimitInvoiceIntervenant(get(props.listings, 'appConfig', []))
          }
        />
      )}
      <RejectFeeNoteByLawyerDialog
        open={openRejetFeeNoteDialog}
        onClose={() => setOpenRejetFeeNoteDialog(false)}
        handleValidate={() =>
          handleRejectFeeNote(
            (get(selectedFeeNote, 'id', null) as unknown) as number,
          )
        }
      />
    </div>
  );
};

export default withLoading(injectIntl(FeeNoteTable), [LOADERS.FEE_NOTE]);
